export const VALIDATE_USER_DETAILS = (orgId: string, email: string) => {
  return `/base/organizations/${orgId}/users/validate-user?email=${email}`;
};

export const VALIDATE_ENTITY_ACCESS_FOR_ORG = (
  orgId: string,
  target: string
) => {
  return `/base/organizations/${orgId}/access/${target}`;
};

export const ACKNOWLEDGE_SUBMISSION_REQUEST =
  '/base/submission-requests/acknowledge-request';
